import { render, staticRenderFns } from "./ConfirmedWarrantsDash.vue?vue&type=template&id=5f6ac0cc"
import script from "./ConfirmedWarrantsDash.vue?vue&type=script&lang=js"
export * from "./ConfirmedWarrantsDash.vue?vue&type=script&lang=js"
import style0 from "./ConfirmedWarrantsDash.vue?vue&type=style&index=0&id=5f6ac0cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports